import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { LogIn, ShieldCheck, Heart, Users } from 'lucide-react';
import Logo from '@/components/Logo';
import { useAuth } from '@/context/AuthContext';
import { useEffect } from 'react';

export default function Login() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate(user.status === 'approved' ? '/member/dashboard' : '/pending-approval');
    }
  }, [user, navigate]);

  const startGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/member/dashboard';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <section className="min-h-[80vh] bg-moj-cream flex items-center justify-center py-16 px-4">
      <div className="max-w-md w-full card-moj p-8 sm:p-10">
        <div className="flex justify-center mb-4"><Logo size="xl" showText={false}/></div>
        <h1 className="font-serif text-3xl text-center text-moj-purple-deep">Members Login</h1>
        <p className="text-center text-moj-charcoal/70 mt-2 mb-8">Sign in with your Google account to access the member dashboard.</p>

        <button onClick={startGoogleLogin} className="btn-primary w-full justify-center" data-testid="google-signin-btn">
          <svg width="20" height="20" viewBox="0 0 24 24"><path fill="#fff" d="M21.35 11.1h-9.18v2.93h5.27c-.23 1.47-1.62 4.3-5.27 4.3-3.17 0-5.76-2.62-5.76-5.85S8.99 6.6 12.17 6.6c1.8 0 3.02.77 3.71 1.43l2.53-2.43C16.84 4.13 14.7 3.2 12.17 3.2 7.13 3.2 3.07 7.26 3.07 12.3s4.06 9.1 9.1 9.1c5.25 0 8.73-3.69 8.73-8.89 0-.59-.07-1.04-.15-1.41z"/></svg>
          Continue with Google
        </button>

        <div className="mt-8 grid grid-cols-3 gap-3 text-center text-xs text-moj-charcoal/70">
          <div><ShieldCheck size={22} className="text-moj-purple mx-auto mb-1"/><div>Secure</div></div>
          <div><Users size={22} className="text-moj-purple mx-auto mb-1"/><div>Family-Friendly</div></div>
          <div><Heart size={22} className="text-moj-purple mx-auto mb-1"/><div>Prayer-Centered</div></div>
        </div>

        <div className="text-center text-xs text-moj-charcoal/60 mt-8 leading-relaxed">
          New members will receive a profile that an admin or pastor will review and approve before full dashboard access. By signing in you agree to our <Link to="/privacy" className="text-moj-purple underline">Privacy Notice</Link>.
        </div>
      </div>
    </section>
  );
}
